
export const animNumber = (
    start: number, 
    end: number, 
    duration: number, 
    setNumber: (number: number) => void,
    withSound?: boolean
) => { 
    // const audio = new Audio('./sounds/points_count.mp3');
    // audio.play();
    const iteration = duration / 10;
    const step = (Math.abs(end) - Math.abs(start)) / iteration;

    // if (withSound) {
    //     audio.play();
    //     audio.volume = 0.05;
    // }

    const interval = setInterval(() => {
        start += step;
        setNumber(start);
        if (Math.abs(start) >= Math.abs(end)) {
            clearInterval(interval);
        }
    }, 10);

}
    
